/* global INTERNAL_URL */

import BaseApi from 'common/api/base';

export default class InternalApi extends BaseApi {
  constructor() {
    super();
    this.baseUrl = INTERNAL_URL;
  }

  policy() {
    return this.fetch('GET', 'policy');
  }

  acceptPolicy() {
    return this.fetch('PUT', 'policy');
  }
}



// WEBPACK FOOTER //
// ./src/common/api/InternalApi.js